import React, { useState, useEffect, FC } from 'react';
import { Button, Text } from '@fullstory/components';
import { copy } from '@fullstory/util/clipboard';
import css from './index.module.scss';
import { useIntl } from 'react-intl';

const TIMEOUT = 3000;

type CopyTextBtnProps = React.ComponentProps<typeof Text> & {
  text: string;
};

/**
 * @deprecated This is a legacy interaction. We already have other copy text options coded.
 * We need to create a unified copy btn interaction.
 */
export const CopyTextBtn: FC<CopyTextBtnProps> = ({ text, children, ...rest }) => {
  const intl = useIntl();
  const [displayText, setDisplayText] = useState(children);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    // Set a timeout to show the original text again
    if (displayText !== children) {
      timeoutId = setTimeout(() => {
        setDisplayText(children);
      }, TIMEOUT);
    }

    return () => clearTimeout(timeoutId);
  }, [displayText, setDisplayText, children]);

  const handleClick = () => {
    const copied = copy(text);
    setDisplayText(
      copied
        ? intl.formatMessage({ defaultMessage: 'Copied!', id: '0oL1zz' })
        : intl.formatMessage({ defaultMessage: 'Error copying to clipboard', id: 'vYmzBn' }),
    );
  };

  return (
    <Button
      data-component="CopyTextBtn"
      onClick={handleClick}
      variant="minimal"
      className={css.copyBtn}
    >
      <Text {...rest}>{displayText}</Text>
    </Button>
  );
};
